export const DataStorage = sessionStorage;
export const KEY_ACCESS_TOKEN = 'access_token';
export const VERSION = '1.0.26'
export const KEY_AUTH_TYPE = "auth_type"
export const KEY_SSO_USER = 'sso_user'
